import React,{Component} from 'react';
import {
    View,
    TextInput,
    TouchableOpacity,
    Platform,
    Text, I18nManager

} from "react-native"
import {typeExport} from "./../redux/store/type";
import {moderateScale} from "./../tools/Scaling";
import * as Colors from "./../tools/Colors";
import HMTextView from "./HMTextView";
import HMIcon from "./HMIcon";
//import Icon from 'react-native-vector-icons/Fonts/FontAwesome';
//import {Icon} from "native-base";

import i18n from "../I18n/i18n";
// import {Tools} from "../tools/Tools";
import {CheckValue} from "../tools/Tools1";

import {isMobile} from "react-device-detect";

let container = null;
export default class HMTextInput extends Component {

    constructor(props) {
        super(props);
        container = this;
        this.state = {
            onPressStatusVoice: false,
            secureText:true

            // value: 'احمد'
        }
    }


    componentWillReceiveProps(props) {


    }


    componentDidMount() {
        if (this.props.onRef != null) {
            this.props.onRef(this)
        }
        if (global._recognition) {
            global._recognition.onresult = function (event) {
                console.log("Value is ", event.results)
                // setValues(event.results[0][0].transcript)
                //container.setState({values: event.results[0][0].transcript})
                container.setState({values: event.results[0]})

            }
        }

    }

    componentWillUnmount() {
    }


    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {secureTextEntry,isPassword, customShowPasswordComponent, customHidePasswordComponent, multiline, _ref, SpeechToText, title, text, value, styleRoot, style, styleTitle, type, cammas, onChangeText, onPressClear, placeholder, lang, noLangTitle, onSubmitEditing, keyboardType, styleIcon} = this.props;
        let checkClear = onPressClear && value && value.length > 0;
        let fontSizeIcon = null;
        let colorIcon = null;
        let {secureText} = this.state;

        title = CheckValue(title);
        placeholder = CheckValue(placeholder);
        title = lang ? i18n.t(title) : title;
        placeholder = lang ? i18n.t(placeholder) : placeholder;


        return (
            <View style={[styleRoot]}>
                {
                    title ?
                        <HMTextView
                            style={[{marginVertical: moderateScale(4), fontSize: moderateScale(15)}, styleTitle]}
                            text={title}
                            type={"bold"}
                        />
                        :
                        null

                }

                <View style={[{flexDirection: 'row',}]}>
                    {
                        // Platform.OS === "web" ?
                        //     <input
                        //         {...this.props}
                        //         ref={_ref}
                        //
                        //         name="username"
                        //         // className="input100" id="username_input" type="text" name="username"
                        //         placeholder={placeholder}
                        //       //  onKeyDown={onSubmitEditing}
                        //         style={Object.assign({
                        //             height: moderateScale(40),
                        //             color: Colors.colorDarkText,
                        //             borderColor: Colors.light43, borderBottomWidth: moderateScale(1),
                        //           //  textAlign: I18nManager.getConstants().isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                        //             width: "100%",
                        //             paddingHorizontal: moderateScale(6),
                        //             fontFamily: typeExport.regularFontName,
                        //             paddingEnd: checkClear ? moderateScale(32) : 0
                        //             // outline: 'none'
                        //         }, style)}
                        //         _vkenabled="true"
                        //
                        //         /*     style={[{
                        //                  height: moderateScale(40),
                        //                  color: Colors.colorDarkText,
                        //                  borderColor: Colors.light43, borderBottomWidth: moderateScale(1),
                        //                  textAlign: I18nManager.getConstants().isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                        //                  width: "100%",
                        //                  paddingHorizontal: moderateScale(6),
                        //                  fontFamily: typeExport.regularFontName,
                        //                  paddingEnd: checkClear ? moderateScale(32) : 0
                        //                  // outline: 'none'
                        //              }, style]}*/
                        //     />
                        //     :

                        <TextInput
                            {...this.props}
                            //   ref={_ref}
                            ref={input => this.textInput = input}
                            style={[multiline ? {} : {height: moderateScale(40),}, {
                                outlineColor: Colors.transparent,

                                color: Colors.colorDarkText,
                                borderColor: Colors.light43, borderBottomWidth: moderateScale(1),
                                textAlign: I18nManager.getConstants().isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                                width: "100%",
                                paddingHorizontal: moderateScale(6),
                                fontFamily: typeExport.regularFontName,
                                paddingEnd: checkClear ? moderateScale(32) : 0
                                // outline: 'none'
                            }, style]}
                            placeholder={placeholder}
                            underlineColorAndroid={"transparent"}
                            secureTextEntry={
                                isPassword !== undefined ? isPassword && secureText : secureTextEntry ? secureTextEntry : false
                            }
                            keyboardType={keyboardType && isMobile ? keyboardType : "default"}
                            //   clearButtonMode="always"
                        />
                    }


                    {
                        checkClear ?
                            <TouchableOpacity
                                onPress={onPressClear}

                                style={{
                                    width: moderateScale(24),
                                    height: moderateScale(24),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginVertical: moderateScale(6),
                                    backgroundColor: Colors.gray,
                                    borderRadius: moderateScale(12),
                                    position: 'absolute',
                                    right: 0,
                                    marginHorizontal: moderateScale(4)


                                }}
                            >

                                <HMIcon name={"ios-close"}/>
                                {/*      <Icon
                                    name="md-woman-sharp"
                                    style={{
                                    color: Colors.red,
                                    fontSize: moderateScale(18),
                                    //  padding: moderateScale(4),
                                    alignSelf: "center",
                                }}/>*/}
                                {/*   <HMTextView
                                    style={{
                                        fontSize: moderateScale(10)
                                    }}
                                    text={"X"}
                                    type={"bold"}
                                />*/}
                            </TouchableOpacity>
                            :
                            null

                    }
                    {
                        global._recognition && SpeechToText ?
                            <TouchableOpacity
                                // ref={ref => {
                                //     this.recorderRef.current = ref
                                // }}
                                activeOpacity={1}
                                // onPress={() => {
                                //     container.setState(
                                //         {
                                //             playState: 'record',
                                //             visibleModal: "selectaudio",
                                //             Modalcategory: true,
                                //             showMessageInput: false,
                                //         },
                                //         () => {
                                //             // container.onShow("selectaudio")
                                //
                                //             // container._playWeb()
                                //
                                //         }
                                //     )
                                //
                                //
                                // }}
                                onPressIn={() => {
                                    //   container.props.clearState();
                                    //container.startAudio()
                                    this.setState({onPressStatusVoice: true});
                                    global._recognition.start();

                                }}
                                onPressOut={() => {
                                    this.setState({onPressStatusVoice: false});

                                    //  container.setState({values: event.results[0][0].transcript})

                                    if (this.state.values) {
                                        var str = "";
                                        for (let i = 0; i < this.state.values.length; i++) {
                                            str += this.state.values[i].transcript + (i === (this.state.values.length - 1) ? " " : "");
                                        }

                                        onChangeText(str);
                                        if (!this.props.value)
                                            this.textInput.setNativeProps({text: str});
                                    }

                                    global._recognition.abort();
                                    global._recognition.stop();


                                }}

                                style={[{
                                    // width:"100%",
                                    // height: "100%",
                                    // width: moderateScale(62),
                                    // height: moderateScale(62),
                                    //   backgroundColor: '#27eeee',
                                    // width: moderateScale(48),
                                    // height: moderateScale(48),
                                    // backgroundColor: '#ee005b',
                                    //position: 'absolute',
                                    //  borderRadius: moderateScale(24),
                                    margin: moderateScale(4),
                                    //  top: 0,
                                    //  left: 0,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    // alignSelf: "center",
                                }, style]}>

                                <HMIcon
                                    // type={""}
                                    name={"mic"}
                                    style={[{
                                        width: moderateScale(container.state.onPressStatusVoice ? 30 : (fontSizeIcon ? fontSizeIcon : 24)),
                                        height: moderateScale(container.state.onPressStatusVoice ? 30 : (fontSizeIcon ? fontSizeIcon : 24)),
                                        textAlign: 'center',
                                        //alignSelf: 'flex-end',
                                        color: container.state.onPressStatusVoice ? Colors.red : (colorIcon ? colorIcon : Colors.blackLight),
                                        // width: moderateScale(32),
                                        // height: moderateScale(32),
                                        fontSize: moderateScale(container.state.onPressStatusVoice ? 30 : (fontSizeIcon ? fontSizeIcon : 24))
                                    }, styleIcon]}/>

                            </TouchableOpacity>
                            :
                            null

                    }
                    {isPassword && (
                        <TouchableOpacity
                            style={{
                                width: moderateScale(24),
                                height: moderateScale(24),
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginVertical: moderateScale(6),
                                backgroundColor: Colors.gray,
                                borderRadius: moderateScale(12),
                                position: 'absolute',
                                right: moderateScale(checkClear ? 26 : 2),
                                marginHorizontal: moderateScale(4)
                            }}
                            onPress={() => this._toggleVisibility()}
                        >
                            {secureText && customShowPasswordComponent !== undefined ? (
                                customShowPasswordComponent
                            ) : !secureText && customHidePasswordComponent !== undefined ? (
                                customHidePasswordComponent
                            ) : (
                                <HMIcon name={"md-home"} resizeMode="contain" style={{
                                    height: 25,
                                    width: 25,
                                    alignSelf: 'center',
                                }}/>
                            )}
                        </TouchableOpacity>
                    )}
                </View>
            </View>

        );
    }

    _toggleVisibility(toggle) {
        var {secureText, onTogglePassword} = this.state;
        if (toggle === undefined) {
            if (onTogglePassword) {
                // onTogglePassword(!secureText);
                this.setState({
                    onTogglePassword: !secureText
                })
            }
            this.setState({
                secureText: !secureText
            })
            secureText ? this.setFocus() : this.setBlur();
        } else {
            if (!((secureText && !toggle) || (!secureText && toggle))) {
                if (onTogglePassword) {
                    //onTogglePassword(!toggle);
                    this.setState({
                        onTogglePassword: !toggle
                    })
                }
                // this.setState({
                //     secureText:!toggle
                // })
                // setSecureText(!toggle);
                toggle ? this.setFocus() : this.setBlur();
            }
        }
    }

    setFocus() {
        this.textInput?.focus();
    }

    setBlur() {
        this.textInput?.blur();
    }
}
